<p-table [value]="queue.businessTransactionDetails" [paginator]="true" [rows]="25"
    [globalFilterFields]="['assignedUserLoginName','agentName','customerName','transactionType','displayUpdatedDate','status','displayElapsedTime']"
    [customSort]="false" sortMode="multiple" [multiSortMeta]="multiSortMeta"
    #table #dt>
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" pInputText size="50" placeholder="Filter Results..."
                    (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="'assignedUserLoginName'">
                Assigned To
                <p-sortIcon [field]="'assignedUserLoginName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'agentName'">
                Agent
                <p-sortIcon [field]="'agentName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'customerName'">
                Customer Name
                <p-sortIcon [field]="'customerName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'transactionType'">
                Service
                <p-sortIcon [field]="'transactionType'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'status'">
                Status
                <p-sortIcon [field]="'status'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'updatedDate'" class="w--date">
                Elapsed Time
                <p-sortIcon [field]="'updatedDate'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'appointmentDate'">
                Appointment Time
                <p-sortIcon [field]="'appointmentDate'"></p-sortIcon>
            </th>
            <th class="w--actions-3">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-businessTransaction let-rowIndex="rowIndex">
        <tr>
            <td>
                <select-assignment
                    [businessTransaction]="businessTransaction"
                    [canManageWorkQueue]="queue.canManageWorkQueue"
                    [masterDropdownList]="masterDropdownList"
                    [userName]="user.userName" (onAssignDropDown)="assignDropDown($event)">
                </select-assignment>
            </td>
            <td class="td--hover-show">{{businessTransaction.agentName}}</td>
            <td class="td--hover-show">{{businessTransaction.customerName}}</td>
            <td><a href="javascript:void(0)"
                (click)="redirectToMyTransaction(businessTransaction)">{{businessTransaction.transactionType}}</a>
            </td>
            <td>{{businessTransaction.status}}</td>
            <td [title]="businessTransaction.displayUpdatedDate">
                {{businessTransaction.displayElapsedTime}}
            </td>
            <td>
                {{businessTransaction.appointmentDate | date:'medium'}}
            </td>
            <td>
                <service-icons
                    [businessTransactionId]="+businessTransaction.transactionId"
                    [showServiceIcons]="businessTransaction.statusTypeId === wipStatuses.Active.id || businessTransaction.statusTypeId === wipStatuses.Inactive.id"
                    [disableRemove]="!canRemove(businessTransaction)"
                    [disableUnassign]="!canUnassign(businessTransaction)"
                    (onHold)="holdTransaction($event)"
                    (onRemove)="removeTransaction($event)"
                    (onUnassign)="unassignTransaction($event)">
                </service-icons>
            </td>
        </tr>
    </ng-template>
</p-table>